var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeaker1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.572,
    height: 20.379,
    viewBox: "0 0 25.572 20.379",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1133.261 -2078.821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.238,25.362a1.092,1.092,0,0,1-1.644.941L4.838,21.752a1.091,1.091,0,0,0-.552-.15H1.092A1.092,1.092,0,0,1,0,20.511V13.136a1.092,1.092,0,0,1,1.092-1.092H4.263a1.091,1.091,0,0,0,.587-.171l7.709-4.917a1.092,1.092,0,0,1,1.678.92Z",
    transform: "translate(1133.261 2072.391)",
    fill: "#ff6633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,119.5l0,0a.914.914,0,0,1-.148-1.171,5.128,5.128,0,0,0,.026-5.957.911.911,0,1,1,1.5-1.04,6.936,6.936,0,0,1,.012,8,.913.913,0,0,1-1.38.171",
    transform: "translate(846.349 1973.671)",
    fill: "#ff6633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.287,66.788h0a.9.9,0,0,1-.023-1.194c1.345-1.582,4.377-6.217-.076-11.989a.9.9,0,0,1,.127-1.235l.012-.01a.9.9,0,0,1,1.3.132c5.182,6.7,1.648,12.289.02,14.26a.9.9,0,0,1-1.362.035",
    transform: "translate(810.049 2029.399)",
    fill: "#ff6633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.879,11.177a14.728,14.728,0,0,1-4.087,8.918.911.911,0,0,1-1.355-.036l.039.045-.041-.047a.909.909,0,0,1,.028-1.214,13.038,13.038,0,0,0,3.6-7.8c.2-3.186-1.038-6.392-3.684-9.541A.911.911,0,1,1,381.772.324c2.966,3.528,4.345,7.176,4.107,10.853",
    transform: "translate(772.928 2078.821)",
    fill: "#ff6633"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker1);
export default __webpack_public_path__ + "static/media/Speaker1.69e69951f2cd428368810551fb5cadd4.svg";
export { ForwardRef as ReactComponent };